import {useMemo} from 'react'
import {Empty, Space, Table, Typography} from 'antd'
import EllipsisTooltip from '../common/EllipsisTooltip'
import RecordsCount from '../common/RecordsCount'
import {formatDateTime, formatEmptyValue} from '../../utils/common'
import {useIntl} from 'react-intl'

const UsageReportTable = ({
  dataSource,
  pagination = false,
  getReportsData = null,
}) => {
  const intl = useIntl()

  const columns = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: 'usageReport.date' }),
        dataIndex: 'created_at',
        width: '25%',
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text ? formatDateTime(text) : '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'usageReport.user' }),
        dataIndex: 'user_name',
        width: '25%',
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {formatEmptyValue(text)}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'usageReport.activity' }),
        dataIndex: 'activity',
        width: '50%',
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {formatEmptyValue(text)}
          </EllipsisTooltip>
        ),
      },
    ],
    [intl]
  )

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ width: '100%', verticalAlign: 'top' }}
    >
      <Table
        rowKey={(record) => `usage-report-${record.id}`}
        columns={columns}
        dataSource={dataSource}
        showSorterTooltip={false}
        tableLayout="fixed"
        pagination={
          pagination
            ? {
                current: pagination?.currentPage,
                total: pagination?.totalCount,
                pageSize: 10,
                showSizeChanger: false,
                hideOnSinglePage: true,
                showTotal: (total) => <RecordsCount count={total} />,
                onChange: (page) => {
                  const offset = (page - 1) * 10
                  const url = pagination?.nextPageLink
                    ? new URL(pagination?.nextPageLink)
                    : new URL(pagination?.prevPageLink)
                  url.searchParams.set('offset', offset)
                  getReportsData?.(url.toString())
                },
              }
            : false
        }
        locale={{
          emptyText: (
            <div style={{ padding: '40px' }}>
              <Empty
                description={intl.formatMessage({
                  id: 'usageReport.usageNotExists',
                })}
              />
            </div>
          ),
        }}
      />
      {pagination && pagination?.totalPages <= 1 && pagination?.totalCount > 0 && (
        <Typography.Text>
          <RecordsCount count={pagination?.totalCount} />
        </Typography.Text>
      )}
    </Space>
  )
}

export default UsageReportTable
